export const APP_NAME = 'ShopOver';